import tmhRequest from '@/config/tmhRequest'


export default {
    searchListOtherOrderLog: function (data) {
        return tmhRequest({
            url: '/order/otherorderlog/searchlistotherorderlog',
            method: 'post',
            data: data,
        })
    },
    addOtherOrderLog: function (data) {
        return tmhRequest({
            url: '/order/otherorderlog/addotherorderlog',
            method: 'post',
            params: data,
        })
    },

    searchOtherOrderByPage: function (data) {
        return tmhRequest({
            url: '/order/otherorder/searchotherorderbypage',
            method: 'post',
            data: data,
        })
    },

    closeOtherOrder: function (data) {
        return tmhRequest({
            url: '/order/otherorder/closeotherorder',
            method: 'post',
            params: data,
        })
    },

    startOtherOrder: function (data) {
        return tmhRequest({
            url: '/order/otherorder/startotherorder',
            method: 'post',
            params: data,
        })
    },

    finishOtherOrder: function (data) {
        return tmhRequest({
            url: '/order/otherorder/finishotherorder',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/order/otherorderlog.js